"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Input = _interopRequireDefault(require("../../Input"));
var _withFormat = require("../../../hocs/withFormat");
var _userflow = require("../../../utils/userflow");
var _currency = require("../../../utils/currency");
var formatPlaceholder = function formatPlaceholder(placeholder) {
  return (0, _isNumber2["default"])(placeholder) ? (0, _userflow.formatDecimal)(placeholder) : placeholder;
};
var PriceFilterInput = function PriceFilterInput(_ref) {
  var value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    className = _ref.className,
    currencyCode = _ref.currencyCode;
  return /*#__PURE__*/_react["default"].createElement(InputWrap, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    position: "left"
  }, label), /*#__PURE__*/_react["default"].createElement(StyledInput, {
    maxLength: 9,
    placeholder: formatPlaceholder(placeholder),
    onChange: onChange,
    type: "tel",
    value: (0, _isNumber2["default"])(value) ? String(value) : value
  }), /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    position: "right"
  }, (0, _currency.getCurrencySymbol)(currencyCode)));
};
var InputWrap = _styledComponents["default"].div.withConfig({
  displayName: "PriceFilterInput__InputWrap",
  componentId: "sc-y814ey-0"
})(["position:relative;"]);
var StyledLabel = _styledComponents["default"].span.withConfig({
  displayName: "PriceFilterInput__StyledLabel",
  componentId: "sc-y814ey-1"
})(["position:absolute;font-size:inherit;z-index:5;top:50%;pointer-events:none;transform:translateY(-50%);", ";"], function (_ref2) {
  var _ref2$position = _ref2.position,
    position = _ref2$position === void 0 ? 'left' : _ref2$position;
  return "".concat(position, ": 10px");
});
var StyledInput = (0, _styledComponents["default"])((0, _withFormat.withDecimalFormat)(_Input["default"])).withConfig({
  displayName: "PriceFilterInput__StyledInput",
  componentId: "sc-y814ey-2"
})(["width:100%;font-size:inherit;text-align:right;padding-right:20px;padding-left:25px;border-color:", ";&::placeholder{color:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.greyLight;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.frenchGray;
});
var _default = exports["default"] = PriceFilterInput;